/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavGeoCode
 */
export interface OutputUavGeoCode {
    /**
     * 
     * @type {string}
     * @memberof OutputUavGeoCode
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavGeoCode
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavGeoCode
     */
    id?: number;
    /**
     * Label — що показується на мапі: назва НП із газетира або власний підпис точки.
     * @type {string}
     * @memberof OutputUavGeoCode
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavGeoCode
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavGeoCode
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavGeoCode
     */
    placeId?: number;
    /**
     * 
     * @type {number}
     * @memberof OutputUavGeoCode
     */
    scopeId?: number;
    /**
     * ScopeName — назва підрозділу (або позивний екіпажу), щоб таблиця не робила ще один запит.
     * @type {string}
     * @memberof OutputUavGeoCode
     */
    scopeName?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavGeoCode
     */
    scopeType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavGeoCode
     */
    source?: string;
}

/**
 * Check if a given object implements the OutputUavGeoCode interface.
 */
export function instanceOfOutputUavGeoCode(value: object): boolean {
    return true;
}

export function OutputUavGeoCodeFromJSON(json: any): OutputUavGeoCode {
    return OutputUavGeoCodeFromJSONTyped(json, false);
}

export function OutputUavGeoCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavGeoCode {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'] == null ? undefined : json['label'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lon': json['lon'] == null ? undefined : json['lon'],
        'placeId': json['placeId'] == null ? undefined : json['placeId'],
        'scopeId': json['scopeId'] == null ? undefined : json['scopeId'],
        'scopeName': json['scopeName'] == null ? undefined : json['scopeName'],
        'scopeType': json['scopeType'] == null ? undefined : json['scopeType'],
        'source': json['source'] == null ? undefined : json['source'],
    };
}

export function OutputUavGeoCodeToJSON(value?: OutputUavGeoCode | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'comment': value['comment'],
        'id': value['id'],
        'label': value['label'],
        'lat': value['lat'],
        'lon': value['lon'],
        'placeId': value['placeId'],
        'scopeId': value['scopeId'],
        'scopeName': value['scopeName'],
        'scopeType': value['scopeType'],
        'source': value['source'],
    };
}

